import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrTake_5Page } from './klmr-take-5';

@NgModule({
  declarations: [
    KlmrTake_5Page,
  ],
  imports: [
    IonicPageModule.forChild(KlmrTake_5Page),
  ],
})
export class KlmrTake_5PageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-take-5/klmr-take-5.module.ts